import React from "react";
import { classes } from './CarouselStyles.js';
import { Box } from '@mui/material';
import rightNav from '../assets/images/right_nav.svg';
import leftNav from '../assets/images/left-nav.svg';

export default function CrsButton({ direction, moveBanner}) {
  return (
    <Box
      component='button'
      onClick={moveBanner}
      sx={[
        classes.btnSlide,
        direction === "next" ? classes.next : classes.prev
      ]}
    >
      <img
        src={direction === "next" ? rightNav : leftNav}
        alt= "directional-button"
        style={{
          filter: 'invert(1) brightness(2)'
        }}
      />
    </Box>
  )
}